const rules = {
  required: {
    validate(value) {
      return {
        required: true,
        // eslint-disable-next-line
        valid: ['', null, undefined].indexOf(value) === -1,
      }
    },
    computesRequired: true,
  },
  'required-select': {
    validate(value) {
      return {
        required: true,
        valid: value !== 0,
      }
    },
    computesRequired: true,
  },
  'requiredSelect': {
    validate(value) {
      return {
        required: true,
        valid: value !== 0,
      }
    },
    computesRequired: true,
  },
  'required-radio': {
    validate(value) {
      return {
        required: true,
        valid: value !== 0,
      }
    },
    computesRequired: true,
  },
  'requiredRadio': {
    validate(value) {
      return {
        required: true,
        valid: value !== 0,
      }
    },
    computesRequired: true,
  },
  'required-checkbox': {
    validate(value) {
      return {
        required: true,
        valid: value === true,
      }
    },
    computesRequired: true,
  },
  'requiredCheckbox': {
    validate(value) {
      return {
        required: true,
        valid: value === true,
      }
    },
    computesRequired: true,
  },
}

export default extend => {
  Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule])
  })
}
